'use client';

import { useUser } from "@descope/nextjs-sdk/client";
import * as _descope_core_js_sdk from '@descope/core-js-sdk';

export interface UserDetailsProps {
    selectedAttribute?: keyof _descope_core_js_sdk.UserResponse;
}

export const UserDetails = ({ selectedAttribute }: UserDetailsProps) => {
    const { user } = useUser();
    if (!user) {
        return null;
    }

    const selectedValue = user[selectedAttribute || 'name'];
    return <span>{selectedValue?.toString() || ''}</span>;
}